const doc = [({"ko":({"adminConstantHotelDisplayCalendarType":({"displayed":"표시하다", "hidden":"표시되지 않음", "hideButton":"가격 표시 버튼 숨기기"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;